import { render, staticRenderFns } from "./tiles.vue?vue&type=template&id=7547c215&scoped=true&"
import script from "./tiles.vue?vue&type=script&lang=js&"
export * from "./tiles.vue?vue&type=script&lang=js&"
import style0 from "./tiles.vue?vue&type=style&index=0&id=7547c215&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7547c215",
  null
  
)

export default component.exports